import React from 'react';
import { useLocation } from 'react-router-dom';
import { Chip, Tooltip } from '@mui/material';

// P1–P111 : route → page number + short name
// กลุ่ม: General(1-3) Project(4-9) Finance(10-23) Customer(24-32)
//        Director(33-36) HR(37-53,111) Management(54-72) Monitor(73-74)
//        Profile(75-86) Sale(87-105) Manpower(106-110)
const ROUTE_MAP = [
  // ─── General ───
  { p: 1,   name: 'Home',                   pattern: /^\/$/ },
  { p: 2,   name: 'Login',                  pattern: /^\/auth\/login$/ },
  { p: 3,   name: 'Register',               pattern: /^\/auth\/login\/register/ },

  // ─── Project ───
  { p: 4,   name: 'Project · Dashboard',    pattern: /^\/project\/dashboard/ },
  { p: 5,   name: 'Project · List',         pattern: /^\/project\/project$/ },
  { p: 6,   name: 'Project · New',          pattern: /^\/project\/project\/new/ },
  { p: 7,   name: 'Project · Detail',       pattern: /^\/project\/project\/detail/ },
  { p: 8,   name: 'Project · Edit',         pattern: /^\/project\/project\/edit/ },
  { p: 9,   name: 'Project · Log',          pattern: /^\/project\/activity-log/ },

  // ─── Finance ───
  { p: 10,  name: 'Finance · Expenses',     pattern: /^\/finance\/expenses$/ },
  { p: 11,  name: 'Finance · AllExpenses',  pattern: /^\/finance\/expenses\/all/ },
  { p: 12,  name: 'Finance · EditExpense',  pattern: /^\/finance\/expenses\/edit/ },
  { p: 13,  name: 'Finance · ExpDetail',    pattern: /^\/finance\/expenses\/detail/ },
  { p: 14,  name: 'Finance · Billing',      pattern: /^\/finance\/billing$/ },
  { p: 15,  name: 'Finance · BillingDetail',pattern: /^\/finance\/billing\/detail/ },
  { p: 16,  name: 'Finance · DailyReport',  pattern: /^\/finance\/daily-report/ },
  { p: 17,  name: 'Finance · Payment',      pattern: /^\/finance\/Payment$/ },
  { p: 18,  name: 'Finance · AddPayment',   pattern: /^\/finance\/Payment\/add/ },
  { p: 19,  name: 'Finance · Timestamp',    pattern: /^\/finance\/timestamp/ },
  { p: 20,  name: 'Finance · ExpApprovers', pattern: /^\/finance\/expense-approvers/ },
  { p: 21,  name: 'Finance · Summary',      pattern: /^\/finance\/summary$/ },
  { p: 22,  name: 'Finance · Archive',      pattern: /^\/finance\/summary\/archive/ },
  { p: 23,  name: 'Finance · Log',          pattern: /^\/finance\/activity-log/ },

  // ─── Customer ───
  { p: 24,  name: 'Customer · List',        pattern: /^\/customer\/customers$/ },
  { p: 25,  name: 'Customer · Client',      pattern: /^\/customer\/client/ },
  { p: 26,  name: 'Customer · Suppliers',   pattern: /^\/customer\/suppliers/ },
  { p: 27,  name: 'Customer · New',         pattern: /^\/customer\/customers\/new/ },
  { p: 28,  name: 'Customer · Edit',        pattern: /^\/customer\/customer\/edit/ },
  { p: 29,  name: 'Customer · Detail',      pattern: /^\/customer\/customer\// },
  { p: 30,  name: 'Customer · Types',       pattern: /^\/customer\/customer-types/ },
  { p: 31,  name: 'Customer · EditType',    pattern: /^\/customer\/customer-type\/edit/ },
  { p: 32,  name: 'Customer · Log',         pattern: /^\/customer\/activity-log/ },

  // ─── Director ───
  { p: 33,  name: 'Director · Project',     pattern: /^\/director\/project/ },
  { p: 34,  name: 'Director · Business',    pattern: /^\/director\/business/ },
  { p: 35,  name: 'Director · HR',          pattern: /^\/director\/hr/ },
  { p: 36,  name: 'Director · Expenses',    pattern: /^\/director\/approve-expenses/ },

  // ─── HR (Humen) ───
  { p: 37,  name: 'HR · Report',            pattern: /^\/humen\/report$/ },
  { p: 38,  name: 'HR · DailyReport',       pattern: /^\/humen\/reportDaily/ },
  { p: 39,  name: 'HR · CheckIn Mgmt',      pattern: /^\/humen\/checkin-management/ },
  { p: 40,  name: 'HR · Timestamp',         pattern: /^\/humen\/timestamp$/ },
  { p: 41,  name: 'HR · TimestampDash',     pattern: /^\/humen\/timestamp-dashboard/ },
  { p: 42,  name: 'HR · EditTimestamp',     pattern: /^\/humen\/timestamp\/edit/ },
  { p: 43,  name: 'HR · OT Request',        pattern: /^\/humen\/ot-request$/ },
  { p: 44,  name: 'HR · Add OT',            pattern: /^\/humen\/ot-request\/add/ },
  { p: 45,  name: 'HR · Edit OT',           pattern: /^\/humen\/ot-request\/edit/ },
  { p: 46,  name: 'HR · Employees',         pattern: /^\/humen\/employee$/ },
  { p: 47,  name: 'HR · EmployeeDetail',    pattern: /^\/humen\/employee\/detail/ },
  { p: 48,  name: 'HR · AddEmployee',       pattern: /^\/humen\/employee\/add/ },
  { p: 49,  name: 'HR · EditEmployee',      pattern: /^\/humen\/employee\/edit/ },
  { p: 50,  name: 'HR · SalaryList',        pattern: /^\/humen\/salarylist$/ },
  { p: 51,  name: 'HR · SalaryDetail',      pattern: /^\/humen\/salarylist\/detail/ },
  { p: 52,  name: 'HR · AddSalary',         pattern: /^\/humen\/salarylist\/add/ },
  { p: 53,  name: 'HR · Log',               pattern: /^\/humen\/activity-log/ },

  // ─── Management ───
  { p: 54,  name: 'Mgmt · Business',        pattern: /^\/management\/business$/ },
  { p: 55,  name: 'Mgmt · EditBusiness',    pattern: /^\/management\/business\/edit/ },
  { p: 56,  name: 'Mgmt · Employees',       pattern: /^\/management\/employee$/ },
  { p: 57,  name: 'Mgmt · EditEmployee',    pattern: /^\/management\/employee\/edit/ },
  { p: 58,  name: 'Mgmt · Departments',     pattern: /^\/management\/department$/ },
  { p: 59,  name: 'Mgmt · EditDept',        pattern: /^\/management\/department\/edit/ },
  { p: 60,  name: 'Mgmt · Users',           pattern: /^\/management\/user\/?$/ },
  { p: 61,  name: 'Mgmt · EditUser',        pattern: /^\/management\/user\/edit/ },
  { p: 62,  name: 'Mgmt · RoleTypes',       pattern: /^\/management\/role-type\/?$/ },
  { p: 63,  name: 'Mgmt · EditRole',        pattern: /^\/management\/role-type\/edit/ },
  { p: 64,  name: 'Mgmt · Notify',          pattern: /^\/management\/notify$/ },
  { p: 65,  name: 'Mgmt · Holidays',        pattern: /^\/management\/holiday$/ },
  { p: 66,  name: 'Mgmt · EditHoliday',     pattern: /^\/management\/holiday\/edit/ },
  { p: 67,  name: 'Mgmt · PayTypes',        pattern: /^\/management\/paytype/ },
  { p: 68,  name: 'Mgmt · TransTypes',      pattern: /^\/management\/transection-type/ },
  { p: 69,  name: 'Mgmt · Developer',       pattern: /^\/management\/developer/ },
  { p: 70,  name: 'Mgmt · Log',             pattern: /^\/management\/activity-log/ },
  { p: 71,  name: 'Mgmt · NotifyRedirect',  pattern: /^\/management\/notify\/redirect$/ },
  { p: 72,  name: 'Mgmt · NotifyTS',        pattern: /^\/management\/notify\/redirect-timestamp/ },

  // ─── Monitor ───
  { p: 73,  name: 'Monitor · Dashboard',    pattern: /^\/monitor\/dashboard$/ },
  { p: 74,  name: 'Monitor · Dashboard2',   pattern: /^\/monitor\/dashboard2/ },

  // ─── Profile ───
  { p: 75,  name: 'Profile · Home',         pattern: /^\/profile\/?$/ },
  { p: 76,  name: 'Profile · OT',           pattern: /^\/profile\/ot$/ },
  { p: 77,  name: 'Profile · Add OT',       pattern: /^\/profile\/ot\/add/ },
  { p: 78,  name: 'Profile · Timestamp',    pattern: /^\/profile\/timestamp$/ },
  { p: 79,  name: 'Profile · Check-In',     pattern: /^\/profile\/timestamp\/Check-In/ },
  { p: 80,  name: 'Profile · Check-Out',    pattern: /^\/profile\/timestamp\/Check-out/ },
  { p: 81,  name: 'Profile · OT (TS)',      pattern: /^\/profile\/timestamp\/ot\/add/ },
  { p: 82,  name: 'Profile · Settings',     pattern: /^\/profile\/profile/ },
  { p: 83,  name: 'Profile · Disbursement', pattern: /^\/profile\/disbursement$/ },
  { p: 84,  name: 'Profile · EditDisb.',    pattern: /^\/profile\/disbursement\/edit/ },
  { p: 85,  name: 'Profile · DisbDetail',   pattern: /^\/profile\/disbursement\/detail/ },
  { p: 86,  name: 'Profile · Calendar',     pattern: /^\/profile\/calendar/ },

  // ─── Sale ───
  { p: 87,  name: 'Sale · Quotations',      pattern: /^\/sale\/quotation$/ },
  { p: 88,  name: 'Sale · CreateQuotation', pattern: /^\/sale\/quotation\/create/ },
  { p: 89,  name: 'Sale · NewContact',      pattern: /^\/sale\/quotation\/contact\/new/ },
  { p: 90,  name: 'Sale · ContactList',     pattern: /^\/sale\/quotation\/contactlist/ },
  { p: 91,  name: 'Sale · QuotationDetail', pattern: /^\/sale\/quotation\/detail/ },
  { p: 92,  name: 'Sale · EditQuotation',   pattern: /^\/sale\/quotation\/edit/ },
  { p: 93,  name: 'Sale · Invoices',        pattern: /^\/sale\/invoice$/ },
  { p: 94,  name: 'Sale · CreateInvoice',   pattern: /^\/sale\/invoice\/create/ },
  { p: 95,  name: 'Sale · EditInvoice',     pattern: /^\/sale\/invoice\/edit/ },
  { p: 96,  name: 'Sale · Receipts',        pattern: /^\/sale\/receipt$/ },
  { p: 97,  name: 'Sale · CreateReceipt',   pattern: /^\/sale\/receipt\/create/ },
  { p: 98,  name: 'Sale · EditReceipt',     pattern: /^\/sale\/receipt\/edit/ },
  { p: 99,  name: 'Sale · BillingNotes',    pattern: /^\/sale\/billingnotes$/ },
  { p: 100, name: 'Sale · CreateBilling',   pattern: /^\/sale\/billingnotes\/create/ },
  { p: 101, name: 'Sale · EditBilling',     pattern: /^\/sale\/billingnotes\/edit/ },
  { p: 102, name: 'Sale · Documents',       pattern: /^\/sale\/documents$/ },
  { p: 103, name: 'Sale · NewDocument',     pattern: /^\/sale\/documents\/new/ },
  { p: 104, name: 'Sale · DocumentDetail',  pattern: /^\/sale\/documents\/.+/ },
  { p: 105, name: 'Sale · ItemTemplates',   pattern: /^\/sale\/item-templates/ },

  // ─── Manpower ───
  { p: 106, name: 'MP · CheckTimestamp',    pattern: /^\/manpower\/CheckTimeStamp/ },
  { p: 107, name: 'MP · CheckIn',           pattern: /^\/manpower\/timestamp\/checkin/ },
  { p: 108, name: 'MP · CheckOut',          pattern: /^\/manpower\/timestamp\/checkout/ },
  { p: 109, name: 'MP · OT',               pattern: /^\/manpower\/ot/ },
  { p: 110, name: 'MP · Timestamp',         pattern: /^\/manpower\/timestamp/ },

  // ─── HR (เพิ่มเติม) ───
  { p: 111, name: 'HR · HrReportV2',        pattern: /^\/humen\/hr-report-v2/ },
  { p: 112, name: 'HR · PayrollAdmin',      pattern: /^\/humen\/payroll-admin/ },
];

// ── Dialog / Modal badge (fixed, above route badge) ───────────────────────────
// Usage: <DevWinBadge num={111} name="Project · Popup" open={!!selectedId} />
export function DevWinBadge({ num, name, open }) {
  if (process.env.NODE_ENV !== 'development' || !open) return null;
  return (
    <Tooltip title={name || ''} placement="top-end" arrow>
      <Chip
        label={`P${num}`}
        size="small"
        sx={{
          position: 'fixed',
          bottom: 48,
          right: 12,
          zIndex: 9999,
          backgroundColor: 'rgba(21, 101, 192, 0.9)',
          color: '#fff',
          fontWeight: 800,
          fontSize: 12,
          fontFamily: 'monospace',
          letterSpacing: '0.04em',
          backdropFilter: 'blur(4px)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.35)',
          cursor: 'default',
          minWidth: 36,
        }}
      />
    </Tooltip>
  );
}

// ── Route badge (auto-detects page from URL) ───────────────────────────────────
export default function DevPageBadge() {
  const { pathname } = useLocation();

  if (process.env.NODE_ENV !== 'development') return null;

  const match = ROUTE_MAP.find(({ pattern }) => pattern.test(pathname));

  return (
    <Tooltip
      title={match ? match.name : pathname}
      placement="top-end"
      arrow
    >
      <Chip
        label={match ? `P${match.p}` : 'P?'}
        size="small"
        sx={{
          position: 'fixed',
          bottom: 12,
          right: 12,
          zIndex: 9999,
          backgroundColor: 'rgba(230, 81, 0, 0.9)',
          color: '#fff',
          fontWeight: 800,
          fontSize: 12,
          fontFamily: 'monospace',
          letterSpacing: '0.04em',
          backdropFilter: 'blur(4px)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.35)',
          cursor: 'default',
          minWidth: 36,
        }}
      />
    </Tooltip>
  );
}
